(function () {
  'use strict';

  var cache = new Map();

  function productByHandle(handle) {
    var key = 'handle:' + handle;
    if (!cache.has(key)) {
      cache.set(key, fetchJson(storeRoot() + 'products/' + encodeURIComponent(handle) + '.js').catch(function () {
        cache.delete(key);
        return null;
      }));
    }
    return cache.get(key);
  }

  async function drawerRecommendations(widget, cart) {
    if (widget.dataset.rielliRecommendationMode === 'automatic') {
      return automaticRecommendations(cart);
    }
    var manualOffer = widget.previousElementSibling;
    var handles = manualOffer ? Array.from(manualOffer.querySelectorAll('[data-handle]')).map(function (node) {
      return node.dataset.handle;
    }) : [];
    handles = Array.from(new Set(handles)).slice(0, 12);
    var cartIds = new Set(cart.items.map(function (item) { return String(item.product_id); }));
    var products = await Promise.all(handles.map(productByHandle));
    products = products.filter(function (product) { return availableRecommendation(product, cartIds); });
    return products.slice(0, 3);
  }

  async function automaticRecommendations(cart) {
    var cartIds = new Set(cart.items.map(function (item) { return String(item.product_id); }));
    var seedIds = Array.from(new Set(cart.items.map(function (item) { return item.product_id; }))).slice(0, 3);
    var results = [];
    var seen = new Set();
    // Try complementary products across all seeds before filling with related products.
    for (var intent of ['complementary', 'related']) {
      for (var seedId of seedIds) {
        var products = await recommendations(seedId, intent);
        for (var product of products) {
          if (availableRecommendation(product, cartIds) && !seen.has(String(product.id))) {
            results.push(product);
            seen.add(String(product.id));
            if (results.length === 3) return results;
          }
        }
      }
    }
    return results;
  }

  function scrollPositions(track) {
    var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    var first = track.firstElementChild;
    var positions = [0];
    if (first) {
      var origin = first.getBoundingClientRect().left;
      Array.from(track.children).forEach(function (card) {
        var position = Math.min(maximum, Math.max(0, card.getBoundingClientRect().left - origin));
        if (positions.every(function (existing) { return Math.abs(existing - position) > 2; })) positions.push(position);
      });
    }
    if (maximum > 2 && positions.every(function (position) { return Math.abs(position - maximum) > 2; })) positions.push(maximum);
    return positions.sort(function (left, right) { return left - right; });
  }

  function updateArrows(widget) {
    var track = widget.querySelector('[data-rielli-cart-offer-product]');
    var overflow = Math.max(0, track.scrollWidth - track.clientWidth);
    var position = Math.min(overflow, Math.max(0, track.scrollLeft));
    widget.querySelector('[data-rielli-cart-offer-arrows]').hidden = overflow <= 2;
    widget.querySelector('[data-rielli-cart-scroll="-1"]').disabled = position <= 2;
    widget.querySelector('[data-rielli-cart-scroll="1"]').disabled = position >= overflow - 2;
  }

  function renderDrawerOffers(widget, products) {
    var holder = widget.querySelector('[data-rielli-cart-offer-product]');
    holder.replaceChildren();
    widget.querySelector('[data-rielli-cart-offer-label]').textContent = 'Complete the look';
    widget.querySelector('[data-rielli-cart-offer-arrows]').hidden = products.length < 2;
    products.forEach(function (product) {
      var variants = product.variants.filter(function (variant) { return variant.available; });
      var card = document.createElement('article');
      card.className = 'rielli-cart-offer__card';
      var imageLink = document.createElement('a');
      imageLink.className = 'rielli-cart-offer__image';
      imageLink.href = productUrl(product);
      imageLink.setAttribute('aria-label', product.title);
      var source = product.featured_image && (product.featured_image.src || product.featured_image);
      if (source) {
        var image = document.createElement('img');
        var imageUrl = new URL(source, window.location.href);
        imageUrl.searchParams.set('width', '380');
        image.src = imageUrl.toString();
        image.alt = product.title;
        image.loading = 'lazy';
        image.width = 190;
        image.height = 145;
        imageLink.appendChild(image);
      }
      var title = document.createElement('a');
      title.className = 'rielli-cart-offer__title';
      title.href = productUrl(product);
      title.textContent = product.title;
      var price = document.createElement('p');
      price.className = 'rielli-cart-offer__price';
      price.textContent = (product.price_varies ? 'From ' : '') + priceText(product.price_min || product.price);
      var form = document.createElement('form');
      form.action = storeRoot() + 'cart/add';
      form.method = 'post';
      form.setAttribute('data-product-form', '');
      var controls = document.createElement('div');
      controls.className = 'rielli-cart-offer__controls';
      var button;
      // Products requiring a selling plan still use their product page to choose it.
      if (product.requires_selling_plan) {
        button = document.createElement('a');
        button.href = productUrl(product);
        button.textContent = 'Choose options';
      } else {
        button = document.createElement('button');
        button.type = 'button';
        button.name = 'add';
        button.textContent = 'Add';
        button.setAttribute('data-add-to-cart', '');
        if (product.variants.length > 1) {
          button.removeAttribute('data-add-to-cart');
          button.textContent = 'Choose options';
          button.addEventListener('click', function () { openOptions(widget, product, button); });
        } else {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'id';
          input.value = variants[0].id;
          form.appendChild(input);
        }
      }
      button.className = 'rielli-cart-offer__action';
      button.setAttribute('aria-label', button.textContent + ' ' + product.title);
      controls.appendChild(button);
      form.appendChild(controls);
      var error = document.createElement('div');
      error.setAttribute('data-cart-errors-container', '');
      error.setAttribute('role', 'alert');
      form.appendChild(error);
      card.appendChild(imageLink);
      card.appendChild(title);
      card.appendChild(price);
      card.appendChild(form);
      holder.appendChild(card);
    });
    widget.hidden = !products.length;
    holder.rielliScrollTarget = null;
    holder.scrollLeft = 0;
    requestAnimationFrame(function () { updateArrows(widget); });
  }

  var activeOptionsDialog;

  function openOptions(widget, product, trigger) {
    if (activeOptionsDialog) activeOptionsDialog.close();
    var dialog = document.createElement('dialog');
    dialog.className = 'rielli-cart-options';
    dialog.setAttribute('aria-label', 'Choose options for ' + product.title);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'rielli-cart-options__close';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close product options');
    close.addEventListener('click', function () { dialog.close(); });
    var heading = document.createElement('h3');
    heading.textContent = 'Choose options';
    var summary = document.createElement('div');
    summary.className = 'rielli-cart-options__summary';
    var source = product.featured_image && (product.featured_image.src || product.featured_image);
    if (source) {
      var image = document.createElement('img');
      image.src = source;
      image.alt = product.title;
      summary.appendChild(image);
    }
    var info = document.createElement('div');
    var title = document.createElement('p');
    title.textContent = product.title;
    var price = document.createElement('p');
    price.textContent = (product.price_varies ? 'From ' : '') + priceText(product.price_min || product.price);
    price.setAttribute('aria-live', 'polite');
    info.append(title, price);
    summary.appendChild(info);
    var form = document.createElement('form');
    form.action = storeRoot() + 'cart/add';
    form.method = 'post';
    form.setAttribute('data-product-form', '');
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    form.appendChild(input);
    var selected = [];
    var groups = [];
    var optionNames = (product.options || []).map(function (option) { return option.name || option; });
    var variantValues = function (variant) {
      return variant.options || [variant.option1, variant.option2, variant.option3].filter(function (value) { return value != null; });
    };
    if (!optionNames.length) optionNames = ['Option'];
    var valuesFor = function (variant) { return optionNames.length === 1 && !variantValues(variant).length ? [variant.title] : variantValues(variant); };
    var add = document.createElement('button');
    add.type = 'button';
    add.name = 'add';
    add.className = 'rielli-cart-options__add btn';
    add.textContent = 'Select options';
    add.disabled = true;
    add.setAttribute('data-add-to-cart', '');
    function update() {
      groups.forEach(function (radios, index) {
        radios.forEach(function (radio) {
          radio.disabled = !product.variants.some(function (variant) {
            return variant.available && valuesFor(variant)[index] === radio.value &&
              selected.slice(0, index).every(function (value, before) { return !value || valuesFor(variant)[before] === value; });
          });
          if (radio.disabled && radio.checked) {
            radio.checked = false;
            selected[index] = undefined;
          }
        });
      });
      var variant = selected.filter(Boolean).length === optionNames.length && product.variants.find(function (candidate) {
        return candidate.available && valuesFor(candidate).every(function (value, index) { return value === selected[index]; });
      });
      input.value = variant ? variant.id : '';
      add.disabled = !variant;
      add.textContent = variant ? 'Add to cart · ' + priceText(variant.price) : 'Select options';
      if (variant) price.textContent = priceText(variant.price);
    }
    optionNames.forEach(function (name, index) {
      var fieldset = document.createElement('fieldset');
      fieldset.className = 'rielli-cart-options__group';
      var legend = document.createElement('legend');
      legend.textContent = name;
      fieldset.appendChild(legend);
      var values = Array.from(new Set(product.variants.map(function (variant) { return valuesFor(variant)[index]; }).filter(Boolean)));
      var radios = values.map(function (value) {
        var label = document.createElement('label');
        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'rielli-option-' + index;
        radio.value = value;
        radio.addEventListener('change', function () { selected[index] = value; update(); });
        var text = document.createElement('span');
        text.textContent = value;
        label.append(radio, text);
        fieldset.appendChild(label);
        return radio;
      });
      groups.push(radios);
      form.appendChild(fieldset);
    });
    var error = document.createElement('div');
    error.setAttribute('data-cart-errors-container', '');
    error.setAttribute('role', 'alert');
    form.append(add, error);
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    form.addEventListener('click', function (event) {
      if (event.target.closest('[data-add-to-cart]') && !input.value) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    dialog.append(close, heading, summary, form);
    dialog.addEventListener('click', function (event) {
      var bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
    ['keydown', 'keyup'].forEach(function (type) {
      dialog.addEventListener(type, function (event) { if (event.key === 'Escape') event.stopPropagation(); });
    });
    var onAdded = function () { dialog.close(); };
    document.addEventListener('theme:cart:added', onAdded);
    dialog.addEventListener('close', function () {
      document.removeEventListener('theme:cart:added', onAdded);
      if (activeOptionsDialog === dialog) activeOptionsDialog = null;
      dialog.remove();
      if (trigger.isConnected) trigger.focus();
      else widget.closest('[data-cart-drawer]')?.querySelector('[data-cart-drawer-toggle]')?.focus();
    });
    widget.closest('[data-cart-drawer]').appendChild(dialog);
    activeOptionsDialog = dialog;
    update();
    dialog.showModal();
  }

  function initDrawer(widget) {
    if (widget.rielliDrawerInitialized) return;
    widget.rielliDrawerInitialized = true;
    var track = widget.querySelector('[data-rielli-cart-offer-product]');
    widget.querySelectorAll('[data-rielli-cart-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var positions = scrollPositions(track);
        var current = track.rielliScrollTarget == null ? Math.max(0, track.scrollLeft) : track.rielliScrollTarget;
        var forward = Number(button.dataset.rielliCartScroll) > 0;
        var target = forward ? positions.find(function (position) { return position > current + 2; }) :
          positions.slice().reverse().find(function (position) { return position < current - 2; });
        if (target == null) target = forward ? positions[positions.length - 1] : 0;
        track.rielliScrollTarget = target;
        track.scrollTo({ left: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('pointerdown', function () { track.rielliScrollTarget = null; });
    track.addEventListener('touchstart', function () { track.rielliScrollTarget = null; }, { passive: true });
    track.addEventListener('scroll', function () {
      updateArrows(widget);
      window.clearTimeout(track.rielliScrollEndTimer);
      track.rielliScrollEndTimer = window.setTimeout(function () { track.rielliScrollTarget = null; }, 150);
    }, { passive: true });
    new ResizeObserver(function () {
      track.rielliScrollTarget = null;
      updateArrows(widget);
    }).observe(track);
    // Validate before the theme's delegated cart handler receives an Add click.
    widget.addEventListener('click', function (event) {
      var button = event.target.closest('[data-add-to-cart]');
      var select = button && button.closest('form').querySelector('select');
      if (select && !select.value) {
        event.preventDefault();
        event.stopPropagation();
        select.focus();
      }
    });
    widget.addEventListener('submit', function (event) { event.preventDefault(); });
  }

  function storeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchJson(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, options)).then(function (response) {
      if (!response.ok) throw new Error('Request failed');
      return response.json();
    });
  }

  function recommendations(productId, intent) {
    var key = productId + ':' + intent;
    if (!cache.has(key)) {
      var url = storeRoot() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=' + intent;
      cache.set(key, fetchJson(url).then(function (data) {
        return Array.isArray(data.products) ? data.products : [];
      }).catch(function () {
        cache.delete(key);
        return [];
      }));
    }
    return cache.get(key);
  }

  function availableRecommendation(product, cartIds) {
    return product && product.available && Number(product.price) > 0 &&
      !cartIds.has(String(product.id)) && Array.isArray(product.variants) &&
      product.variants.some(function (variant) { return variant.available; });
  }

  async function chooseRecommendation(cart) {
    var cartIds = new Set(cart.items.map(function (item) { return String(item.product_id); }));
    var seedIds = Array.from(new Set(cart.items.map(function (item) { return item.product_id; }))).slice(0, 3);

    for (var i = 0; i < seedIds.length; i += 1) {
      for (var j = 0; j < 2; j += 1) {
        var intent = j === 0 ? 'complementary' : 'related';
        var products = await recommendations(seedIds[i], intent);
        var product = products.find(function (candidate) {
          return availableRecommendation(candidate, cartIds);
        });
        if (product) return { product: product, intent: intent };
      }
    }
    return null;
  }

  function priceText(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || navigator.language, {
        style: 'currency', currency: currency,
        minimumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2
      }).format(Number(cents) / 100);
    } catch (error) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  function productUrl(product) {
    return product.url || storeRoot() + 'products/' + encodeURIComponent(product.handle);
  }

  function renderOffer(widget, result) {
    var product = result.product;
    var variants = product.variants.filter(function (variant) { return variant.available; });
    var oneVariant = product.variants.length === 1;
    var holder = widget.querySelector('[data-rielli-cart-offer-product]');
    var label = widget.querySelector('[data-rielli-cart-offer-label]');
    var error = widget.querySelector('[data-rielli-cart-offer-error]');
    var url = productUrl(product);

    holder.replaceChildren();
    error.hidden = true;
    error.textContent = '';
    label.textContent = result.intent === 'complementary' ? 'Pairs well with' : 'You may also like';

    var imageLink = document.createElement('a');
    imageLink.className = 'rielli-cart-offer__image';
    imageLink.href = url;
    imageLink.setAttribute('aria-label', product.title);
    var imageSource = product.featured_image && (product.featured_image.src || product.featured_image);
    if (imageSource) {
      var image = document.createElement('img');
      var imageUrl = new URL(imageSource, window.location.href);
      imageUrl.searchParams.set('width', '180');
      image.src = imageUrl.toString();
      image.alt = '';
      image.loading = 'lazy';
      image.width = 82;
      image.height = 110;
      imageLink.appendChild(image);
    }

    var info = document.createElement('div');
    info.className = 'rielli-cart-offer__info';
    var title = document.createElement('a');
    title.className = 'rielli-cart-offer__title';
    title.href = url;
    title.textContent = product.title;
    var price = document.createElement('p');
    price.className = 'rielli-cart-offer__price';
    price.textContent = (product.price_varies ? 'From ' : '') + priceText(product.price_min || product.price);

    var action;
    if (oneVariant) {
      action = document.createElement('button');
      action.type = 'button';
      action.textContent = 'Add to bag';
      action.addEventListener('click', async function () {
        action.disabled = true;
        action.textContent = 'Adding…';
        error.hidden = true;
        try {
          await fetchJson(storeRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variants[0].id, quantity: 1 })
          });
          window.location.assign(storeRoot() + 'cart');
        } catch (requestError) {
          error.textContent = 'Could not add this item. Please try again.';
          error.hidden = false;
          action.disabled = false;
          action.textContent = 'Add to bag';
        }
      });
    } else {
      action = document.createElement('a');
      action.href = url;
      action.textContent = 'Choose options';
    }
    action.className = 'rielli-cart-offer__action';

    info.appendChild(title);
    info.appendChild(price);
    info.appendChild(action);
    holder.appendChild(imageLink);
    holder.appendChild(info);
    widget.hidden = false;
  }

  async function refresh(widget) {
    if (!widget.isConnected) return;
    var sequence = (widget.rielliSequence || 0) + 1;
    widget.rielliSequence = sequence;
    var manualOffer = widget.previousElementSibling;
    if (widget.closest('[data-cart-drawer]')) {
      initDrawer(widget);
      try {
        var drawerCart = await fetchJson(storeRoot() + 'cart.js');
        if (sequence !== widget.rielliSequence || !widget.isConnected) return;
        if (!drawerCart.items || !drawerCart.items.length) {
          widget.hidden = true;
          return;
        }
        var drawerProducts = await drawerRecommendations(widget, drawerCart);
        if (sequence !== widget.rielliSequence || !widget.isConnected) return;
        renderDrawerOffers(widget, drawerProducts);
      } catch (error) {
        widget.hidden = true;
      }
      return;
    }
    // Manual mode never replaces an empty product selection with automatic suggestions.
    if (widget.dataset.rielliRecommendationMode !== 'automatic') {
      widget.hidden = true;
      return;
    }
    if (manualOffer && manualOffer.matches('[data-pair-products-holder]') &&
        manualOffer.querySelector('[data-pair-products]')) {
      widget.hidden = true;
      return;
    }

    widget.hidden = true;
    try {
      var cart = await fetchJson(storeRoot() + 'cart.js');
      if (sequence !== widget.rielliSequence || !cart.items || !cart.items.length) return;
      var result = await chooseRecommendation(cart);
      if (sequence !== widget.rielliSequence || !widget.isConnected) return;
      if (result) renderOffer(widget, result);
    } catch (error) {
      widget.hidden = true;
    }
  }

  function schedule(widget) {
    window.clearTimeout(widget.rielliTimer);
    widget.rielliTimer = window.setTimeout(function () { refresh(widget); }, 120);
  }

  function init(root) {
    var widgets = root.querySelectorAll('[data-rielli-cart-offer]');
    widgets.forEach(function (widget) {
      if (widget.rielliInitialized) return;
      widget.rielliInitialized = true;
      var manualOffer = widget.previousElementSibling;
      if (manualOffer && manualOffer.matches('[data-pair-products-holder]')) {
        new MutationObserver(function () { schedule(widget); }).observe(manualOffer, { childList: true });
      }
      schedule(widget);
    });
  }

  function refreshAll() {
    init(document);
    document.querySelectorAll('[data-rielli-cart-offer]').forEach(schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
  document.addEventListener('theme:cart:loaded', refreshAll);
  document.addEventListener('theme:cart:added', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);
}());
